export default "__VITE_ASSET__DY4HhDZb__"